import { Type } from 'class-transformer';
import { ARReversePaymentRawDto } from './ar-reverse-payment-raw-dto';

export class ARReversePaymentEditorResultDto {
    @Type(() => ARReversePaymentRawDto)
    paymentInfo: ARReversePaymentRawDto;
    @Type(() => Date)
    closeBookPeriod: Date;

    @Type(() => Date)
    minReverseDate: Date;
}
